<div class="flex flex-col gap-8 fixed right-4 bottom-4 z-40">

	<div class="relative">
		<div class="bg-peps-gold rounded-full p-3 bottom-4 right-4 cursor-pointer relative w-14 h-14" (click)="toggle()">
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
			     class="size-8 text-white z-10 transition-all duration-300 ease-in-out absolute top-3 left-3"
			     [ngClass]="{'opacity-100 scale-100': !isOpen(), 'opacity-0 scale-75': isOpen()}"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
			</svg>
			<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
			     class="size-8 text-white z-10 transition-all duration-300 ease-in-out absolute top-3 left-3"
			     [ngClass]="{'opacity-0 scale-75': !isOpen(), 'opacity-100 scale-100': isOpen()}"
			>
				<path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
			</svg>
		</div>
	</div>
</div>

<peps-bell-popup
	[isOpen]="isOpen"
	[isSubscribed]="isSubscribed"
	(closePopup)="close()"
	(enableNotification)="enableNotifications()"
	(disableNotification)="disableNotifications()"
></peps-bell-popup>
